import { TabPane } from "reactstrap";
import React, { useState } from "react";
import SettingsPanel from "../../components/SettingsPanel";
import TabEmailAccounts from "./tabEmailAccounts";
import TabEmailTemplate from "./EmailTemplate/tabEmailTemplate";
import TabEmailDomains from "./tabEmailDomains";
import TabEmailRules from "./EmailRules";
// Change #100541 - everything the company has sent.
import TabSentEmails from "./tabSentEmails";

export default function EmailSettings() {
  const Tabs = [
    // {
    //   id: "1",
    //   name: "Email Settings",
    // },
    {
      id: "2",
      name: "Email Accounts",
    },
    {
      id: "3",
      name: "Email Templates",
    },
    {
      id: "4",
      name: "Email Domains",
    },
    {
      id: "5",
      name: "Email Rules",
    },
    {
      id: "6",
      name: "Sent Emails",
    },
  ];

  const Content = [
    // {
    //   id: "1",
    //   content: <TabEmailSettings />,
    // },
    {
      id: "2",
      content: <TabEmailAccounts />,
    },
    {
      id: "3",
      content: <TabEmailTemplate />,
    },
    {
      id: "4",
      content: <TabEmailDomains />,
    },
    {
      id: "5",
      content: <TabEmailRules />,
    },
    {
      id: "6",
      content: <TabSentEmails />,
    },
  ];
  const [activeTab, setActiveTab] = useState("2");

  return (
    <SettingsPanel
      title="Email Settings"
      description="Email accounts, templates, domains and forwarding rules for your CRMit inbox."
      tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      {/* The forwarding note is about receiving mail; it only confuses the
          Sent Emails tab. */}
      {activeTab !== "6" && (
      <div className={"pt-2 pb-2"}>
        <div>
          <h5>Email forwarding setup</h5>
          <div>
            <p className={"text-muted"}>
              To start receiving emails to your CRMit account please forward any
              of your mailboxes to Email Address below, you can create new
              account Simply Click Email Account
            </p>
            <hr />
          </div>
        </div>
      </div>
      )}
      <TabPane tabId={activeTab}>
        {Content.find((item) => item.id === activeTab)?.content}
      </TabPane>
    </SettingsPanel>
  );
}
